var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "hPa-control", attrs: { id: "hPa_control" } },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("v-slider", {
        attrs: {
          max: _vm.hPa_sliders.length - 1,
          ticks: "always",
          "tick-labels": _vm.hPa_sliders,
          "hide-details": ""
        },
        on: {
          change: function($event) {
            return _vm.set_dropsonde({ hPa: _vm.hPa_sliders[_vm.hPa_index] })
          }
        },
        model: {
          value: _vm.hPa_index,
          callback: function($$v) {
            _vm.hPa_index = $$v
          },
          expression: "hPa_index"
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "slider-title" }, [
      _c("span", { staticClass: "slider-title__text" }, [_vm._v("hPa")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }